import React from 'react';
/** icon-chevron-bottom-strong-m */
/** icon-chevron-bottom-strong */
export default () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M3.176 4.962 C 2.903 5.016,2.515 5.356,2.368 5.670 C 2.218 5.991,2.277 6.318,2.538 6.603 C 2.728 6.811,7.133 10.895,7.267 10.987 C 7.491 11.141,7.656 11.186,8.000 11.186 C 8.344 11.186,8.509 11.141,8.733 10.987 C 8.867 10.895,13.272 6.811,13.462 6.603 C 13.833 6.196,13.795 5.734,13.353 5.295 C 12.958 4.902,12.600 4.845,12.195 5.112 C 12.118 5.162,11.146 6.049,10.035 7.081 C 8.923 8.114,8.007 8.959,8.000 8.959 C 7.993 8.959,7.077 8.114,5.965 7.081 C 4.854 6.049,3.882 5.162,3.805 5.112 C 3.592 4.971,3.383 4.922,3.176 4.962 "
            stroke="none"
            fillRule="evenodd"
            fill="#1A2B49"
        />
    </svg>
);
